import styled from 'styled-components';
export const MapBox = styled.div`
  width: 1;
  height: 1;
`;
